module.exports = __webpack_public_path__ + "img/8.0daf42bf.png";